import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
var messageHandlers = {};
var CUSTOM_PROTOCOL_SCHEME = 'tvajsbridge';
var NAMESPACE = 'core';
var responseCallbacks = {};
var isIos = navigator.userAgent.match(/\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/);
var uniqueId = 1;

function send(data, responseCallback) {
  _doSend({
    data: data
  }, responseCallback);
}

function registerHandler() {
  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var handler = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof handler !== 'function') {
    throw new Error('handler 参数类型不合法');
  }

  if (!Array.isArray(messageHandlers[event])) {
    messageHandlers[event] = [];
  }

  messageHandlers[event].push(handler);
}

function callHandler(handlerName, data, responseCallback) {
  _doSend({
    handlerName: handlerName,
    data: data
  }, responseCallback);
}

function _doSend(message, responseCallback) {
  if (responseCallback) {
    var callbackId = "tva_".concat(uniqueId, "_").concat(new Date().getTime());
    uniqueId += 1;
    responseCallbacks[callbackId] = responseCallback;
    message.callbackId = callbackId;
    window[callbackId] = responseCallback;
  }

  var params = '';

  try {
    params = encodeURIComponent(JSON.stringify(message.data));
  } catch (_) {}

  function failCallback() {
    /*
      正常情况下是不会回调到这里的, 只有客户端没有捕获这个 url 请求,
      浏览器才会发起 iframe 的加载, 但这个 url 实际上是不存在的,
      会触发 404 页面的 onload 事件
    */
    responseCallback({
      errCode: -201,
      errMsg: 'call bridge error'
    });
  }

  var iframe = document.createElement('iframe');
  iframe.style.cssText = 'display:none;width:0px;height:0px;'; // Android会触发onload回调，仅用于iOS判断失败

  if (isIos) {
    iframe.onload = failCallback;
  }

  iframe.src = "".concat(CUSTOM_PROTOCOL_SCHEME, "://").concat(NAMESPACE, "/").concat(message.handlerName, "?callback=").concat(message.callbackId, "&params=").concat(params);
  (document.body || document.documentElement).appendChild(iframe);
  setTimeout(function () {
    iframe && iframe.parentNode && iframe.parentNode.removeChild(iframe);
  }, 500);
} // 由客户端执行页面的回调事件


function dispatchEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$messageName = _ref.messageName,
      messageName = _ref$messageName === void 0 ? '' : _ref$messageName,
      _ref$messageParams = _ref.messageParams,
      messageParams = _ref$messageParams === void 0 ? {} : _ref$messageParams;

  if (messageHandlers[messageName]) {
    messageHandlers[messageName].forEach(function (handler) {
      if (typeof handler === 'function') {
        handler(messageParams);
      }
    });
  }
}

var TVAJSBridge = {
  send: send,
  registerHandler: registerHandler,
  callHandler: callHandler,
  on: registerHandler,
  invoke: callHandler,
  dispatchEvent: dispatchEvent
};
export default TVAJSBridge;